import { SelectedData } from 'types/common/FormTypes';
import { PromoConditions } from 'types/promotion/promotionTypes';

export const convertPromoConditionToSelectedData = async (
  data: PromoConditions[] | [],
  isImage = 0
): Promise<SelectedData[]> => {
  if (!data || data.length === 0) {
    return [];
  }

  return data.map((item) => ({
    label: item.name,
    value: item.code.toString(),
    ...(isImage === 1 && { image: item.image?.thumbs }),
  }));
};
